import Prism from 'prismjs/prism.js';
Prism.plugins.autoloader.languages_path = craft.env.assetsSiteUrl + '/assets/js/common/prismjs/components/';
import PrismAutoloader from 'prismjs/plugins/autoloader/prism-autoloader.min.js';
import { throttle } from "../../../lib";
import DOMHelper from "../../../lib/dom-helper";
import HeroSection from "../../components/hero-section";
import Api from "../../../lib/api";
import YoutubeVideo from "../../../components/base/youtube-video";
import EventRegistrationForm from "./event-registration-form";
import PhotoGallery from "../../../components/base/photo-gallery";
import EventDynamicContent from "./event-dynamic-content";
import PaidEventConsultationForm from "./paid-event-consultation-form";

export default class PageModule {
	constructor() {
		this.initEventDynamicContent();
		this.initHeroSection();
		this.initStatusBar();
		this.initEventRegistrationForm();
		this.initYoutubeVideoSections();
		this.initPhotoGallery();
		this.handleRecommendedCourseLinks();
	}

	initEventDynamicContent() {
		const dynamicContentModule = new EventDynamicContent();
	}

	initHeroSection() {
		const heroSection = new HeroSection();
	}

	/**
	 * Adds '-pinned' class, when the top edge of viewport reaches the status bar
	 */
	initStatusBar() {
		const $statusBar = document.getElementById('heroStatusBar');

		if (!$statusBar) {
			return;
		}

		const $postEntrySection = document.querySelector('.section.-post-entry');

		window.addEventListener('scroll', throttle(() => {
			const media = window.matchMedia('(min-width: 769px)').matches;

			if (media) {
				const statusBarYPos = DOMHelper.getElementTopPosition($postEntrySection) - $statusBar.offsetHeight - 20 - 42;
				const windowYPos = window.scrollY;

				if (windowYPos >= statusBarYPos) {
					$statusBar.classList.add('-pinned');
				} else {
					$statusBar.classList.remove('-pinned');
				}
			}
		}, 20));
	}

	initEventRegistrationForm() {
		const eventRegistrationForm = new EventRegistrationForm();

		if (craft.page.isPaidEvent) {
			const paidEventConsultationForm = new PaidEventConsultationForm();
		}
	}

	initYoutubeVideoSections() {
		const $videoSections = document.querySelectorAll('.post-constructor-youtube');

		if ($videoSections.length) {
			$videoSections.forEach(($videoSection) => {
				const youtubeVideo = new YoutubeVideo($videoSection);
			});
		}
	}

	initPhotoGallery() {
		const photoGallery = new PhotoGallery();
	}

	/* Switch href of course link to the current city link */
	handleRecommendedCourseLinks() {
		const $courseLinks = document.querySelectorAll('.recommended-course-link');

		if (!$courseLinks.length) {
			return;
		}

		$courseLinks.forEach(($courseLink) => {
			const cityId = Api.currentCityId;

			if ($courseLink.dataset && $courseLink.dataset[cityId]) {
				$courseLink.href = $courseLink.dataset[cityId];
			}

			if (cityId === 'online') {
				$courseLink.classList.add('-online');
			}
		});
	}
}